'use es6';

import I18n from 'I18n';
import { max, intersection } from 'underscore';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getFontOptions, getFontOptionsForCmv2, SYSTEM_FONTS_CMV2 } from 'EmailEditorUI/constants/TemplateSettingsConstants';
import { TRANSACTIONAL_ID } from 'EmailEditorUI/constants/FieldConstants';
import { getFieldGroupForTab } from 'ContentComponents/components/cmv2/utils';
import { STYLE } from 'ContentUtils/constants/CustomWidgetFieldGroupTabTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_FONT = getFontOptions(false)[0].value;
const DEFAULT_FONT_SIZE = 12;
const DEFAULT_FONT_SIZE_UNITS = 'px';
const DEFAULT_FONT_COLOR = '#000';
export function getFieldFromSpec(moduleSpec, fieldName) {
  var _getFieldGroupForTab;
  const contentField = moduleSpec.fields.find(f => f.name === fieldName);
  return contentField || ((_getFieldGroupForTab = getFieldGroupForTab(moduleSpec.fields, STYLE)) === null || _getFieldGroupForTab === void 0 ? void 0 : _getFieldGroupForTab.children.find(f => f.name === fieldName));
}
export const getDefaultFromSpec = (spec, fieldName) => {
  var _getFieldFromSpec;
  return (_getFieldFromSpec = getFieldFromSpec(spec, fieldName)) === null || _getFieldFromSpec === void 0 ? void 0 : _getFieldFromSpec.default;
};
export const isFieldARepeater = (spec, fieldName) => getFieldFromSpec(spec, fieldName).occurrence;
export const generateFontFieldValue = ({
  font,
  fontSize,
  units,
  color,
  bold = false,
  italic = false,
  underline = false
}) => ({
  font: font || DEFAULT_FONT,
  size: {
    value: parseInt(fontSize, 10) || DEFAULT_FONT_SIZE,
    units: units || DEFAULT_FONT_SIZE_UNITS
  },
  color: color || DEFAULT_FONT_COLOR,
  styles: {
    'font-weight': bold ? 'bold' : 'normal',
    'font-style': italic ? 'italic' : 'none',
    'text-decoration': underline ? 'underline' : 'none'
  }
});
function CSSStringToFonts(cssFontString) {
  return cssFontString.toLowerCase().split(',').map(s => s.replace(',', '').replace(/"/g, '').replace(/[‘’']/g, "'"));
}
export const cmv2FontConverter = (font, webfonts = SYSTEM_FONTS_CMV2) => {
  const newChoices = [...getFontOptionsForCmv2(), ...webfonts];
  const defaultValueFonts = font ? CSSStringToFonts(font) : getFontOptionsForCmv2()[0][0];

  // const newDefaultFontChoice = newChoices.find(([choice]) => {
  //   return choice.toLowerCase().startsWith(defaultValueFonts[0]);
  // });

  const newDefaultFontChoice = max(newChoices, ([choice]) => {
    const match = intersection(defaultValueFonts, CSSStringToFonts(choice));
    const index = match.reduce((acc, val) => {
      if (defaultValueFonts.indexOf(val) < acc) {
        return defaultValueFonts.indexOf(val);
      }
      return acc;
    }, defaultValueFonts.length);
    return match.length > 0 ? defaultValueFonts.length - index : -1;
  });
  return newDefaultFontChoice[0];
};
export const getIsDefaultSubscriptionType = (groups, subscriptionId) => {
  var _subscriptionType$sub;
  if (subscriptionId === TRANSACTIONAL_ID) {
    return true;
  }
  const definitions = groups[0].translatedSubscriptionDefinitions || [];
  const subscriptionType = definitions.find(definition => {
    var _definition$subscript;
    return (definition === null || definition === void 0 || (_definition$subscript = definition.subscriptionDefinition) === null || _definition$subscript === void 0 ? void 0 : _definition$subscript.id) === subscriptionId;
  });
  return subscriptionType && ((_subscriptionType$sub = subscriptionType.subscriptionDefinition) === null || _subscriptionType$sub === void 0 ? void 0 : _subscriptionType$sub.defaultSubscription) !== undefined;
};
export function generateWebfontOption(webfonts) {
  return {
    text: /*#__PURE__*/_jsx("div", {
      title: I18n.text('layoutBuilderSidebar.fontSelect.webfontTitle'),
      children: /*#__PURE__*/_jsx(HelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "layoutBuilderSidebar.fontSelect.webfontTooltip"
        }),
        tooltipProps: {
          placement: 'bottom'
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "layoutBuilderSidebar.fontSelect.webfontTitle"
        })
      })
    }),
    options: webfonts
  };
}
//delete with 'Email:CustomFonts' gate
/**
 * @deprecated
 */
export function generateFontOptions(fonts, webfonts) {
  const fontOptions = fonts.reduce((acc, font) => {
    // @bend-expect trellis-tokenized
    const element = /*#__PURE__*/_jsx("span", {
      style: {
        fontFamily: font.value
      },
      children: font.text
    });
    acc[font.text] = Object.assign({}, font, {
      options: true,
      buttonText: element,
      dropdownText: element
    });
    return acc;
  }, {});
  if (!webfonts) {
    return fontOptions;
  }
  return Object.assign({}, fontOptions, {
    webfonts: generateWebfontOption(webfonts)
  });
}
export const safeUppercase = stringToConvert => typeof stringToConvert === 'string' ? stringToConvert.toUpperCase() : stringToConvert;
export const createValidColorHex = color => {
  if (!color) {
    return '000000';
  }
  const containsAllSameLetters = new Set(color).size === 1;
  const trailingCharacter = containsAllSameLetters ? color[0] : '0';
  switch (color.length) {
    case 1:
      return `${color.repeat(6)}`;
    case 2:
      return `${color.repeat(3)}`;
    case 3:
      return [...color].map(value => `${value.repeat(2)}`).join('');
    case 4:
      return `${color}${trailingCharacter.repeat(2)}`;
    case 5:
      return `${color}${trailingCharacter}`;
    default:
      return color;
  }
};